<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
              <el-form-item label="活动名称：">
                <el-input @keyup.enter.native="searchLoad" v-model="formInlineTmp.name" placeholder="请输入活动名称" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="pushToPage" class="add-btn btn-right" style="float: right;">新建</el-button>
      </el-col>
    </el-row>
        <el-row class="import-data-title table-first-style">
          <el-table
            :data="tableData"
            v-loading="loading"
            class="table">
            <el-table-column
              prop="name"
              label="活动名称">
              <template slot-scope="scope">
                <div class="op-link" @click="pushToActivityPage(scope.row.name)">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width=''
              label="抽奖/中奖人次">
              <template slot-scope="scope">
                {{ scope.row.draw_count }} / {{ scope.row.prize_count }}
              </template>
            </el-table-column>
            <el-table-column
              width=''
              label="开始时间">
              <template slot-scope="scope">
                {{ scope.row.start_time | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
              width=''
              label="结束时间">
              <template slot-scope="scope">
                {{ scope.row.updateTime | formatDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
              <template slot-scope="scope">
                <div class="op-link" @click="copyAcivityAction(scope.row)">
                  复制
                </div>
                <div class="op-link">
                  <router-link :to="{ name: 'editPrizeActivity', query: { id: scope.row.name }}">
                    编辑
                  </router-link>
                </div>
                <div class="op-link" @click="deleteAction(scope.row.id)">
                  删除
                </div>
            </template>
          </el-table-column>
        </el-table>
          <div class="table-foot">
            <el-pagination
              class="table-foot-pagination"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="limit"
              layout="total, prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
          <!--添加二维码分组弹窗-->
          <el-dialog class="cellDialog base-dialog" title="二维码" :visible.sync="qrCodedialog" width="620px">
            <el-input id="copyObj" class="qrcode-show-input" type="text" v-model.trim="qrCodeUrl" auto-complete="off" placeholder=""></el-input>
            <el-button class="dialog-confirm-btn" @click="getUrl" style="margin-left: 15px;color: #fff">复制链接</el-button>
            <!--<p style="word-break:break-all;">-->
              <!--{{ qrCodeUrl }}-->
            <!--</p>-->
            <qriously :value="qrCodeUrl" :size="240"/>
            <!-- <div slot="footer" class="dialog-footer" style="margin-top: 10px">
              <el-button class="dialog-cancel-btn" @click="qrCodedialog = false" style="margin-left: 20px">关 闭</el-button>
            </div> -->
          </el-dialog>
        </el-row>
    </div>
</template>
<script>
import { getActivityList, deleteActivity, editActivity, beginActivity, copyAcivity, stopActivity } from '@/api/customer.js'
export default {
  name: 'prizeList',
  data () {
    return {
      loading: true,
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '已发奖',
          value: '0'
        },
        {
          label: '未发奖',
          value: '1'
        }
      ],
      qrCodedialog: false,
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {
      },
      formInline: {
      },
      qrCodeUrl: '',
      limit: 10
    }
  },
  computed: {
    Newitems() {
      let _this = this
      let Newitems = []
      if (_this.formInlineTmp.name === '') {
        return
      }
      console.log('formInlineTmp.name', _this.formInlineTmp)
      if (_this.formInlineTmp.name) {
        _this.tableData.map(function(item) {
          if (item.name.search(_this.formInlineTmp.name) != -1) {
            Newitems.push(item)
          }
        })
      }
      if (_this.formInlineTmp.status) {
        _this.tableData.map(function(item) {
          if (item.status.search(_this.formInlineTmp.status) != -1) {
            Newitems.push(item)
          }
        })
      }
      return Newitems
    }
  },
  methods: {
    // 查找二维码类型
    searchLoad() {
      let flag = 0
      let array = []
      for (let i in this.tableData) {
        // this.groups[i].choosen = false
        for (let j in this.Newitems) {
          if (this.tableData[i].id === this.Newitems[j].id) {
            flag++
            console.log('this.Newitems[j]', this.Newitems[j])
            array.push(this.Newitems[j])
            this.tableData = array
          }
        }
      }
      if (flag === 0) {
        // _g.toastMsg('error', '没有匹配的分组')
        this.tableData = [
          {
            id: 0,
            name: '酒鬼湘泉布奖活动',
            draw_count: '5',
            prize_count: '5',
            start_time: 1556640000,
            updateTime: 1561910400,
            status: 0
          },
          {
            id: 1,
            name: '山东地区布奖活动',
            draw_count: '5',
            prize_count: '2',
            start_time: 1556640000,
            updateTime: 1561910400,
            status: 1
          },
          {
            id: 2,
            name: '30-40岁男客户布奖',
            draw_count: '1',
            prize_count: '1',
            start_time: 1556640000,
            updateTime: 1561910400,
            status: 0
          }
        ]
        this.totalCount = this.tableData.length
      }
    },
    // 获取二维码地址
    getUrl() {
      let url = document.querySelector('#copyObj')
      url.select() // 选择对象
      document.execCommand('Copy')
    },
    // searchLoad() {
    //   this.page = 1
    //   this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
    //   this.getData()
    // },
    pushToActivityPage(id) {
      router.push({name: 'editPrizeActivity', query: { id: id }})
    },
    showQRcode(url) {
      this.qrCodedialog = true
      this.qrCodeUrl = url
    },
    pushToPage() {
      router.push('/home/set-prize-activity')
    },
    // 开始活动
    beginActivityAction(id) {
      beginActivity(id).then((res) => {
        if (res.data.code === 0) {
          this.getData()
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    stopActivityAction(id) {
      let ids = []
      ids.push(id)
      let idStr = ids.toString()
      stopActivity(ids).then(res => {
        if (res.data.code === 0) {
          this.getData()
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 删除活动
    deleteAction(id) {
      this.$confirm('确认删除该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteActivity(id).then((res) => {
          if (res.data.code === 0) {
            let index = this.tableData.indexOf(id)
            this.tableData.splice(index, 1)
            _g.toastMsg('success', '删除活动成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      console.log('handleCurrentChangethis.formInline', this.formInline)
      this.page = page
      this.getData()
    },
    copyAcivityAction(item) {
      setTimeout(() => {
        item.draw_count = 0
        item.prize_count = 0
        this.tableData.push(item)
        _g.toastMsg('success', '复制成功')
      }, 500)
    },
    getData() {
      this.loading = true
      getActivityList(this.page, this.formInline).then(res => {
        this.tableData = [
          {
            id: 0,
            name: '酒鬼湘泉布奖活动',
            draw_count: '3',
            prize_count: '2',
            start_time: 1556640000,
            updateTime: 1561910400,
            status: 0
          },
          {
            id: 1,
            name: '山东地区布奖活动',
            draw_count: '4',
            prize_count: '2',
            start_time: 1556640000,
            updateTime: 1561910400,
            status: 1
          },
          {
            id: 2,
            name: '30-40岁男客户布奖',
            draw_count: '1',
            prize_count: '1',
            start_time: 1556640000,
            updateTime: 1561910400,
            status: 0
          }
        ]
        this.totalCount = this.tableData.length
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  height:40px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
